/**
 * Lux Cart Drawer — enhancement layer.
 * 1) Free shipping progress bar (threshold from Theme settings).
 * 2) Remove-button resilience: if Dawn's cart-remove-button component
 *    isn't registered (script failed/missing), a guarded fallback
 *    removes the line via the Cart AJAX API and re-renders the drawer.
 *    If Dawn's component IS present, the fallback stays inert.
 */
(function () {
  'use strict';

  var settings = window.luxSettings || {};

  /* ======================================================================
     FREE SHIPPING BAR
     ====================================================================== */

  var threshold = parseFloat(settings.freeShippingThreshold);
  var thresholdCents = threshold > 0 ? Math.round(threshold * 100) : 0;
  var pending = null;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withThousands = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var currency = settings.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    return currency === 'PKR' ? 'Rs.' + withThousands : withThousands + ' ' + currency;
  }

  function ensureBar(drawer) {
    var bar = drawer.querySelector('.lux-shipbar');
    if (bar) return bar;

    var header = drawer.querySelector('.drawer__header');
    if (!header) return null;

    bar = document.createElement('div');
    bar.className = 'lux-shipbar';
    bar.innerHTML =
      '<p class="lux-shipbar__label" data-shipbar-label role="status"></p>' +
      '<div class="lux-shipbar__track"><div class="lux-shipbar__fill" data-shipbar-fill></div></div>';
    header.insertAdjacentElement('afterend', bar);
    return bar;
  }

  function updateShipbar() {
    if (!thresholdCents) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (drawer.classList.contains('is-empty')) {
      var existing = drawer.querySelector('.lux-shipbar');
      if (existing) existing.remove();
      return;
    }

    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bar = ensureBar(drawer);
        if (!bar) return;

        var label = bar.querySelector('[data-shipbar-label]');
        var fill = bar.querySelector('[data-shipbar-fill]');
        var total = cart.total_price;

        if (total >= thresholdCents) {
          bar.classList.add('lux-shipbar--unlocked');
          label.innerHTML = '<strong>Complimentary shipping unlocked</strong>';
        } else {
          bar.classList.remove('lux-shipbar--unlocked');
          label.innerHTML =
            '<strong>' + formatMoney(thresholdCents - total) + '</strong> away from complimentary shipping';
          fill.style.width = Math.min(100, (total / thresholdCents) * 100) + '%';
        }
      })
      .catch(function () {});
  }

  function scheduleShipbar() {
    clearTimeout(pending);
    pending = setTimeout(updateShipbar, 200);
  }

  /* ======================================================================
     REMOVE-BUTTON RESILIENCE
     ====================================================================== */

  function rerenderDrawer(cart) {
    var url = window.location.pathname + '?sections=cart-drawer,cart-icon-bubble';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var drawerInner = document.getElementById('CartDrawer');
        if (drawerInner && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.getElementById('CartDrawer');
          if (fresh) drawerInner.innerHTML = fresh.innerHTML;
        }

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
          var bFresh = bDoc.getElementById('cart-icon-bubble');
          if (bFresh) bubble.innerHTML = bFresh.innerHTML;
        }

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl && cart) {
          drawerEl.classList.toggle('is-empty', cart.item_count === 0);
        }

        scheduleShipbar();
      })
      .catch(function () {
        // Absolute last resort: reload keeps the cart truthful.
        window.location.reload();
      });
  }

  function setupRemoveFallback() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('cart-remove-button');
      if (!btn) return;

      // Dawn's component is registered → it owns this click; stay inert.
      if (customElements.get('cart-remove-button')) return;

      event.preventDefault();

      var line = parseInt(btn.dataset.index, 10);
      if (!line) return;

      btn.style.opacity = '0.4';
      btn.style.pointerEvents = 'none';

      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { rerenderDrawer(cart); })
        .catch(function () { window.location.reload(); });
    });
  }

  /* ======================================================================
     INIT
     ====================================================================== */

  function init() {
    var drawer = document.querySelector('cart-drawer');

    if (drawer) {
      new MutationObserver(scheduleShipbar).observe(drawer, {
        childList: true,
        subtree: true
      });
      scheduleShipbar();
    }

    setupRemoveFallback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();